import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

const GetHelpButton = () => {
  const { t } = useTranslation();
  return (
    <Button
      variant='outline'
      className='mt-1 w-fit bg-transparent text-primary-700'
    >
      <a href='https://www.clientpaydirect.com/contact-us/' target='_blank'>
        {t('Get Help')}
      </a>
    </Button>
  );
};

export default GetHelpButton;
